import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './../../assets/icons/user-circle-solid.svg'


const _withScopeId = n => (_pushScopeId("data-v-9d7c1738"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "contact-container pt-5 pb-5 px-4" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Contact Person")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_4 = { class: "row pt-3" }
const _hoisted_5 = {
  key: 0,
  class: "agent-icon",
  src: _imports_0
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "quote" }, "“", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "quote" }, "”", -1))
const _hoisted_9 = { class: "col-12 col-lg-10 justify-content-center align-items-center" }
const _hoisted_10 = {
  class: "row justify-content-center align-items-start pt-3 pt-lg-3",
  style: {"min-height":"100px"}
}
const _hoisted_11 = { class: "d-none d-lg-block px-5 pt-3 bio" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "quote" }, "“", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "quote" }, "”", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ContactAgentField = _resolveComponent("ContactAgentField")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", {
        class: _normalizeClass(["col-lg-2 agent-icon-container", { 'col-4': _ctx.getBio() != '', 'col-12': _ctx.getBio() == '' }])
      }, [
        (_ctx.getProfileImage() === '')
          ? (_openBlock(), _createElementBlock("img", _hoisted_5))
          : _createCommentVNode("", true),
        (_ctx.getProfileImage() !== '')
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "profile-image",
              style: _normalizeStyle('background-image:url(' + _ctx.getProfileImage() + ')')
            }, null, 4))
          : _createCommentVNode("", true)
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["d-block d-lg-none px-3 pt-3 bio", { 'col-8': _ctx.getBio() != '', 'd-none': _ctx.getBio() == '' }])
      }, [
        (_ctx.getBio() != '')
          ? (_openBlock(), _createElementBlock("section", _hoisted_6, [
              _createElementVNode("blockquote", null, [
                _hoisted_7,
                _createTextVNode(" " + _toDisplayString(_ctx.getBio()) + " ", 1),
                _hoisted_8
              ])
            ]))
          : _createCommentVNode("", true)
      ], 2),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_ContactAgentField, {
            class: "col-6 col-lg-3",
            title: "Name",
            content: _ctx.getName()
          }, null, 8, ["content"]),
          _createVNode(_component_ContactAgentField, {
            class: "col-6 col-lg-3",
            title: "Phone",
            content: _ctx.getPhone(),
            isPhone: true
          }, null, 8, ["content"]),
          _createVNode(_component_ContactAgentField, {
            class: "col-6 col-lg-3",
            title: "Agency",
            content: _ctx.getAgency()
          }, null, 8, ["content"]),
          _createVNode(_component_ContactAgentField, {
            class: "col-6 col-lg-3",
            title: "REN No.",
            infoIcon: 'What is REN Tag / No.?\n\nREN Tag is an identification tag issued to a real estate negotiator (REN). It contains all the information including their name, photo, IC no, REN no, firm name, firm registration no, quick respond code (QR) and security features, This tag must be worn by the REN at all times during their conduct od business.',
            content: _ctx.getRegNum()
          }, null, 8, ["infoIcon", "content"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      (_ctx.getBio() != '')
        ? (_openBlock(), _createElementBlock("section", _hoisted_12, [
            _createElementVNode("blockquote", null, [
              _hoisted_13,
              _createTextVNode(" " + _toDisplayString(_ctx.getBio()) + " ", 1),
              _hoisted_14
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}